import {mapMutations, mapActions} from 'vuex';
import randomMixin from './randomInteger';
export default {
    mixins: [randomMixin],
    methods: {
        ...mapMutations({
            setDeleteMessage: 'player-profile/setDeleteMessage',
            setDeleteID: 'player-profile/setDeleteID'
        }),
        ...mapActions({
            destroyItemAction: 'player-profile/destroyItem'
        }),
        destroyProfileItem({id, message, type, callback = null}) {
            this.setDeleteMessage(message);
            let randomID = this.randomInteger(id);
            this.setDeleteID(randomID);

            this.$bus.$on(`proceed-${randomID}`, () => {
                this.destroyItemAction({
                    id,
                    type
                }).then(() => {
                    if (callback) {
                        callback();
                    }
                });
            });
        }
    }
}